import { Address, erc20Abi } from "viem"
import { useAccount, useReadContract } from "wagmi"

import { MEZO_CHAIN } from "#/shared/constants"

export default function useAllowanceERC20Token(
  tokenAddress: Address,
  spender: Address,
  chainId: number = MEZO_CHAIN.id,
) {
  const { address } = useAccount()

  return useReadContract({
    abi: erc20Abi,
    address: tokenAddress,
    functionName: "allowance",
    args: [address!, spender],
    query: { enabled: !!address },
    chainId,
  })
}
